'use client';

// npmモジュール
import { useState, useEffect } from "react";
import Link from "next/link";

// タイプ
import PaginationType from "./PaginationType";
import PAGINATION_DISPLAY_NUMBER from "../../../constants/siteInfo/paginationDisplayNumber";

// 定数

// CSS Modules
import styles from './Pagination.module.scss'

const Pagination = (props: PaginationType) => {
  const { originalActive, totalCount, contentsName, postsPerPage, pageNumber } = props;
  const pageNum = Math.ceil(totalCount / postsPerPage);
  const pageList = Array.from({ length: pageNum }, (_, index) => index + 1);
  const listStartIndex = 1;
  const listLength = pageList.length || 0;
  const displayedListLength = PAGINATION_DISPLAY_NUMBER;

  const [activeItem, setActiveItem] = useState(originalActive);
  const [displayedList, setDisplayedList] = useState<Array<number | string>>(pageList.slice(0, displayedListLength));

  const calculateDisplayedList = (active: number): Array<number | string> => {
    let newList: Array<number | string> = [];

    if (listLength <= displayedListLength) {
      // リスト全体が表示できる場合
      newList = pageList;
    } else {
      // リストを中央に表示
      const halfDisplayed = Math.floor((displayedListLength - 3) / 2); // -3 は最初、最後、'>' の分

      if (active <= halfDisplayed + 1) {
        // ページが最初に近い場合
        newList = [
          ...pageList.slice(0, displayedListLength - 1), // -1 は'>'
          '>',
          listLength
        ];
      } else if (active >= listLength - halfDisplayed) {
        // ページが最後に近い場合
        newList = [
          1,
          '<',
          ...pageList.slice(listLength - (displayedListLength - 1), listLength) // -1 は'<' の分
        ];
      } else if (active == 3) {
        // ページが中央にある場合
        newList = [
          1,
          ...pageList.slice(active - halfDisplayed - 1, active + halfDisplayed),
          '>',
          listLength
        ];
      } else {
        // ページが中央にある場合
        newList = [
          1,
          '<',
          ...pageList.slice(active - halfDisplayed - 1, active + halfDisplayed),
          '>',
          listLength
        ];
      }
    }

    return newList;
  };

  const changeActiveHandler = (clickedIndex: number) => () => {
    if (clickedIndex < listStartIndex) {
      clickedIndex = listStartIndex;
    }
    if (clickedIndex > listLength) {
      clickedIndex = listLength;
    }
    setActiveItem(clickedIndex);
    const newDisplayedList = calculateDisplayedList(clickedIndex);
    setDisplayedList(newDisplayedList);
  }

  useEffect(() => {
    setDisplayedList(calculateDisplayedList(originalActive));
  }, [originalActive]);

  const movePage = (increment: number) => () => {
    const newActive = activeItem + increment;
    if (newActive >= listStartIndex && newActive <= listLength) {
      setActiveItem(newActive);
      setDisplayedList(calculateDisplayedList(newActive));
    }
  };

  return (
    <>
      <ul className={styles.contentsList}>
        <li key="toFirst">
          <Link href={`/` + contentsName}>
            {"<"}
          </Link>
        </li>
        {displayedList.map((data, index) => (
          data === activeItem ? (
            <li key={index} className={styles.active}>
              <span>{data}</span>
            </li>
          ) : data === '<' ? (
            <li key={index} onClick={movePage(-1)}>{data}</li>
          ) : data === '>' ? (
            <li key={index} onClick={movePage(1)}>{data}</li>
          ) : (
            <li key={index}>
              <Link href={`/` + contentsName + `?page=` + data}>{data}</Link>
            </li>
          )
        ))}
        <li key="toLast">
          <Link href={`/` + contentsName + `?page=` + pageNum}>
            {">"}
          </Link>
        </li>
      </ul>
      <div className={styles.pagination__count}>{pageNumber}/{pageNum}ページ</div>
    </>
  );

}

export default Pagination;